import { registerComponent } from '../registry';
import PaymentSuccessComponent from './PaymentSuccess.component';
import PaymentSuccessEditor from './PaymentSuccess.editor';
import PaymentSuccessProperties from './PaymentSuccess.properties';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: 'PAYMENT_SUCCESS', // 타입 상수
  component: PaymentSuccessComponent,
  editorComponent: PaymentSuccessEditor,
  properties: PaymentSuccessProperties as any, // 타입 캐스팅으로 오류 해결
  defaultProps: {
    // 기본 속성 설정
    componentProps: {
      title: '결제가 완료되었습니다',
      successMessage: '결제가 성공적으로 처리되었습니다.',
      orderHistoryButtonText: '주문 내역 확인',
      continueShoppingButtonText: '쇼핑 계속하기',
      showOrderDetails: true,
      redirectToHome: '/',
      redirectToOrderHistory: '/mypage/orderlist',
      loadingText: '결제 정보를 처리 중입니다...',
      waitingMessage: '잠시만 기다려주세요.'
    },
    style: {
      width: '100%'
    }
  },
  category: 'commerce', // 컴포넌트 카테고리
  icon: '✅', // 대표 아이콘
  name: '결제 완료 페이지' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as PaymentSuccessComponent } from './PaymentSuccess.component';
export { default as PaymentSuccessEditor } from './PaymentSuccess.editor';
export { default as PaymentSuccessProperties } from './PaymentSuccess.properties';
export * from './PaymentSuccess.types'; 